<template>
  <div class="login-container">
    <!-- <div style="height: 40px;line-height: 40px;color:#000;position: fixed;left:0;top:0;width:100%;text-align:center;background:#fff;z-index:100;font-size:12px">当前环境：{{ testText }}</div> -->
    <div class="login_center">
      <template v-if="deviceType === 0 || deviceType === 3 || deviceType === 4">
        <div class="logo-box">
          <img src="@/assets/logo.png" />
          <span class="text">数据看板</span>
        </div>
        <div class="logo-text">仅限授权人员查看</div>
      </template>
      <div class="login-box" v-show="deviceType === 0">
        <div class="login-line">
          <div class="form-lable">手机号</div>
          <div class="form-input">
            <input
              type="text"
              class="input"
              maxlength="11"
              v-model="formData.mobile"
              placeholder="请输入手机号"
            />
          </div>
        </div>
        <div class="login-line">
          <div class="form-lable">验证码</div>
          <div class="form-input">
            <input
              type="text"
              class="code-input"
              maxlength="6"
              v-model="formData.code"
              placeholder="请输入验证码"
            />
            <div class="code-btn" v-if="validateType" style="color: #666">{{ time }}秒后重试</div>
            <div class="code-btn" @click="getCode" v-else>获取验证码</div>
          </div>
        </div>
        <!-- <div style="padding-left: 60px">
          <el-checkbox
            v-model="formData.isExtension"
            :true-label="1"
            :false-label="0"
          >
            授权本浏览器长期免登录
          </el-checkbox>
        </div> -->
        <div class="login-btn" @click="loginByCode">登 录</div>
        <div
          class="login-code--text"
          style="cursor:pointer"
          v-if="deviceType === 4||deviceType === 0||deviceType === 5"
          @click="changeLoginMethod"
        >
          {{ deviceType === 4?'切换短信登录':'切换成扫码登录' }}
        </div>
      </div>
      <div class="login-box" v-show="deviceType === 3 || deviceType === 4||deviceType === 5">
        <div class="login-code--text">请使用飞书扫码登录</div>
        <div class="login-code" id="qrCodeUrl" ref="qrCodeUrl"></div>
        <div
          class="login-code--text"
          style="cursor:pointer"
          v-if="deviceType === 4||deviceType === 0||deviceType === 5"
          @click="changeLoginMethod"
        >
          {{ deviceType === 4?'切换短信登录':'切换成扫码登录' }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import jsb from '@swaiot/jssdk'
import { Base64 } from 'js-base64'
let codeTimeout
let shareTimeout
let guidTimeout
export default {
  components: {},
  props: {},
  data () {
    return {
      formData: {
        isExtension: 0
      },
      deviceType: 0,
      time: 60,
      validateType: false,
      access_token: null,
      testText: '其它浏览器',
      url: process.env.VUE_APP_NODE_URL
    }
  },
  methods: {
    changeLoginMethod () {
      this.deviceType = this.deviceType === 4 ? 0 : 4
      if (this.deviceType === 4) {
        this.creatQrCode()
      }
    },
    getShareInfo () {
      if (window.sw) {
        var module = window.sw.require('account')
        module.getAccountInfo('getUserInfo')
      }
    },
    delParam (paramKey) {
      let url = window.location.href // 页面url
      const urlParam = window.location.search.substr(1) // 页面参数
      const beforeUrl = url.substr(0, url.indexOf('?')) // 页面主地址（参数之前地址）
      let nextUrl = ''
      let arr = []
      if (urlParam !== '') {
        const urlParamArr = urlParam.split('&') // 将参数按照&符分成数组
        for (var i = 0; i < urlParamArr.length; i++) {
          const paramArr = urlParamArr[i].split('=') // 将参数键，值拆开
          // 如果键雨要删除的不一致，则加入到参数中
          if (paramArr[0] !== paramKey) {
            arr.push(urlParamArr[i])
          }
        }
      }
      if (arr.length > 0) {
        nextUrl = '?' + arr.join('&')
      }
      url = beforeUrl + nextUrl
      window.alert(url)
      return url
    },
    guid (len = 32, firstU = true, radix = null) {
      let chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz_-'.split('')
      let uuid = []
      radix = radix || chars.length
      if (len) {
        // 如果指定uuid长度,只是取随机的字符,0|x为位运算,能去掉x的小数位,返回整数位
        for (let i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)]
      } else {
        let r
        // rfc4122标准要求返回的uuid中,某些位为固定的字符
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
        uuid[14] = '4'

        for (let i = 0; i < 36; i++) {
          if (!uuid[i]) {
            r = 0 | (Math.random() * 16)
            uuid[i] = chars[i === 19 ? (r & 0x3) | 0x8 : r]
          }
        }
      }
      // 移除第一个字符,并用u替代,因为第一个字符为数值时,该guuid不能用作id或者class
      if (firstU) {
        uuid.shift()
        return 'u' + uuid.join('')
      } else {
        return uuid.join('')
      }
    },
    extension () {
      this.creatQrCode()
    },
    creatQrCode () {
      let vThat = this
      this.$refs.qrCodeUrl.innerHTML = ''
      clearInterval(guidTimeout)
      const guid = this.guid()
      // this.getLoginStatus(guid)
      // console.log(`${window.location.origin}${window.location.pathname}?uniqueId=${guid}`)
      // 企业微信
      // var qrcode = new QRCode(this.$refs.qrCodeUrl, {
      //   text: `${window.location.origin}${window.location.pathname}?uniqueId=${guid}&isExtension=${this.formData.isExtension}`, // 需要转换为二维码的内容
      //   // text: `https://open.feishu.cn/open-apis/authen/v1/index?redirect_uri=https://databoard.coocaa.com/mobile-lists&app_id=cli_a2a45e12e47bd00b&state={STATE}&uniqueId=${guid}`, // 需要转换为二维码的内容
      //   width: 200,
      //   height: 200,
      //   colorDark: '#000000',
      //   colorLight: '#eee',
      //   correctLevel: QRCode.CorrectLevel.H
      // })
      let pathRedirect = this.$route.query.redirect ? `?redirect=${this.$route.query.redirect}` : ''
      pathRedirect += `${pathRedirect ? '&' : '?'}isExtension=${this.formData.isExtension}`

      window.QRLoginObj = QRLogin({
        id: 'qrCodeUrl',
        // goto: `https://passport.feishu.cn/suite/passport/oauth/authorize?client_id=cli_a2a45e12e47bd00b&redirect_uri=http://beta-front-end.coocaa.com:8099/login${pathRedirect}&response_type=code&state=STATE&uniqueId=${guid}`,
        // goto: `https://passport.feishu.cn/suite/passport/oauth/authorize?client_id=cli_a2a45e12e47bd00b&redirect_uri=http://127.0.0.1:8888/login${pathRedirect}&response_type=code&state=STATE&uniqueId=${guid}`,
        // goto: `https://passport.feishu.cn/suite/passport/oauth/authorize?client_id=cli_a2a45e12e47bd00b&redirect_uri=https://databoard.coocaa.com/login${pathRedirect}&response_type=code&state=STATE&uniqueId=${guid}`,
        goto: `https://passport.feishu.cn/suite/passport/oauth/authorize?client_id=cli_a2a45e12e47bd00b&redirect_uri=${vThat.url}/login${pathRedirect}&response_type=code&state=STATE&uniqueId=${guid}`,
        width: '255',
        height: '255'
      })
      var handleMessage = function (event) {
        var origin = event.origin
        // 使用 matchOrigin 方法来判断 message 是否来自飞书页面
        if (window.QRLoginObj.matchOrigin(origin)) {
          var loginTmpCode = event.data
      	// // 在授权页面地址上拼接上参数 tmp_code，并跳转
          window.location.href = `https://passport.feishu.cn/suite/passport/oauth/authorize?client_id=cli_a2a45e12e47bd00b&redirect_uri=${vThat.url}/login${pathRedirect}&response_type=code&state=STATE&uniqueId=${guid}&tmp_code=${loginTmpCode}`
          // window.location.href = `https://passport.feishu.cn/suite/passport/oauth/authorize?client_id=cli_a2a45e12e47bd00b&redirect_uri=http://beta-front-end.coocaa.com:8099/login${pathRedirect}&response_type=code&state=STATE&uniqueId=${guid}&tmp_code=${loginTmpCode}`
          // window.location.href = `https://passport.feishu.cn/suite/passport/oauth/authorize?client_id=cli_a2a45e12e47bd00b&redirect_uri=http://127.0.0.1:8888/login${pathRedirect}&response_type=code&state=STATE&uniqueId=${guid}&tmp_code=${loginTmpCode}`
        }
      }
      if (typeof window.addEventListener !== 'undefined') {
        window.addEventListener('message', handleMessage, false)
      } else if (typeof window.attachEvent !== 'undefined') {
        window.attachEvent('onmessage', handleMessage)
      }
    },
    feishuLogin (code) {
      let pathRedirect = this.$route.query.redirect ? '?redirect=' + this.$route.query.redirect : ''
      if (this.$route.query.isExtension) {
        pathRedirect += `${pathRedirect ? '&' : '?'}isExtension=${this.$route.query.isExtension}`
      }
      this.$service.fsScanAutoLogin(
        {
          redirectUri: window.location.origin + window.location.pathname + pathRedirect,
          code
          // isExtension: this.$route.query.isExtension
        }
      ).then(res => {
        this.loginSuccess(res)
      })
    },
    loginByCode () {
      const mobile = this.formData.mobile
      const code = this.formData.code
      if (mobile && /^1\d{10}$/.test(mobile) && code && code.length === 6) {
        this.$service.loginByCode(this.formData).then(res => {
          if (res) {
            this.loginSuccess(res)
          }
        })
      }
    },
    getCode () {
      console.log(2)
      const mobile = this.formData.mobile
      if (mobile && /^1\d{10}$/.test(mobile)) {
        this.$service.getValidateCode({
          mobile: mobile
        }).then(() => {
          this.time = 60
          this.validateType = true
          codeTimeout = setInterval(() => {
            this.time--
            if (this.time === 0) {
              clearInterval(codeTimeout)
              this.validateType = false
            }
          }, 1000)
        })
      }
    },
    getLoginStatus (id) {
      guidTimeout = setInterval(() => {
        this.$service.getLoginStatus({
          uniqueId: id
        }).then(res => {
          if (res.code === 1000) {
            clearInterval(guidTimeout)
            this.loginSuccess(res.data.token)
          }
        })
      }, 2000)
    },
    loginSuccess (token) {
      localStorage.setItem('token', token)
      console.log(Base64.decode(token))
      let [heder, body, end] = token.split('.')
      localStorage.setItem('userInfo', Base64.decode(body))
      const redirect = this.$route.query.redirect || '/'
      if (redirect) {
        this.$router.push({
          path: redirect.indexOf('?') > 0 ? `${redirect}&token=${token}` : `${redirect}?token=${token}`
        })
      }
    },
    getDeviceInfo () {
      // PC 、 TV   -----   扫码登录  前端生成唯一值   PC\TV根据唯一值查询手机上登录情况
      // 共享屏手机   -----   自动获取共享屏帐号信息登录
      // 企业微信   -----   自动企微授权登录
      // 其它浏览器   -----   输入手机验证码登录
      // 企微>1   共享屏>2   tv>3  PC>4   其它浏览器>0

      const ua = window.navigator.userAgent.toLowerCase()
      const isMobile = this.isAndroid // 手机端
      const isWorkWx = ua.match(/wxwork/) || ua.match(/micromessenger/)// 企微
      const isWorkFs = ua.match(/lark/) || ua.match(/larklocale/)// 飞书
      const isWs = !!this.access_token
      const isTv = (isMobile && document.body.clientWidth > 750)
      if (isMobile) {
        this.testText = `${this.testText} >> 手机`
        if (isWorkWx) {
          const code = this.$route.query.code
          if (code) {
            this.$service.qywxLogin({
              code: code,
              // isExtension: this.$route.query.isExtension,
              uniqueId: this.$route.query.uniqueId
            }).then(res => {
              this.loginSuccess(res.token)
            })
          } else {
            window.location = `http://wx.coocaa.com/weixin.htm?appid=wxc1d38a25a66befce&redirect_uri=${encodeURIComponent(this.delParam('code'))}&scope=snsapi_base#wechat_redirect&response_type=code&state=`
          }
          this.testText = '企微'
          return 1
        } else if (isWorkFs) {
          const code = this.$route.query.code
          if (code) {
            this.$service.feiShuLogin({
              code: this.$route.query.code,
              // isExtension: this.$route.query.isExtension,
              uniqueId: this.$route.query.uniqueId
            }).then(res => {
              this.loginSuccess(res.token)
            })
          }
          this.testText = '飞书'
          return 0
        } else if (isWs) {
          this.$service.shareLogin({
            token: this.access_token
          }).then(res => {
            this.loginSuccess(res.token)
          })
          this.testText = '共享屏'
          return 2
        } else if (isTv) {
          this.creatQrCode()
          this.testText = '电视机'
          return 3
        } else {
          return 0
        }
      } else {
        this.creatQrCode()
        this.testText = 'PC'
        return 4
      }
    }
  },
  mounted () {
    console.log(this.url)
    const account = jsb.requireModule('account')
    account.getAccessToken({
      success: (res) => {
        this.access_token = res.data.accessToken
      }
    })
    setTimeout(() => {
      const deviceType = this.getDeviceInfo()
      this.deviceType = deviceType
      localStorage.setItem('deviceType', deviceType)
    }, 200)
    if (this.$route.query.code) {
      this.feishuLogin(this.$route.query.code)
    }
  },
  computed: {
    isAndroid () {
      let isMobile = this.$store.state.app.isAndroid
      if (isMobile) { this.creatQrCode() }
      return this.$store.state.app.isAndroid
    }
  },
  created () {
    localStorage.removeItem('token')
  }
}
</script>

<style lang="stylus" scoped>
.login-container
  width 100vw
  height 100vh
  background url('~@/assets/lockLogin.gif')
  // background-size cover
  .login_center
    width 380px
    position fixed
    left 50%
    top 50%
    z-index 100
    margin-left -190px
    transform translateY(-50%)
    .logo-box
      text-align center
      line-height 25px
      img
        height 25px
      .text
        font-size 25px
        color #fff
        padding-left 3px
    .logo-text
      text-align center
      line-height 40px
      color rgba(255, 255, 255, .8)
      padding-bottom 20px
    .login-box
      width 330px
      background #fff
      margin 0 auto
      padding-top 15px
      padding-bottom 15px
      .login-code--text
        line-height 40px
        text-align center
        font-size 15px
        width 270px
        margin 0 auto
        color #555
      .login-code
        width 260px
        height 260px
        background #eee
        margin 0 auto
        padding 10px
      .login-line
        height 40px
        line-height 40px
        // border-bottom 1px solid #ccc
        // background #eee
        display flex
        .form-lable
          font-size 14px
          width 50px
          padding-left 10px
          // text-align center
        .form-input
          flex 1
          padding 7px 10px 0 0
          .input
            border 1px solid #ccc
            padding 0
            height 25px
            line-height 25px
            width calc(100% - 2px)
            text-indent 8px
            vertical-align top
          .code-input
            border 1px solid #ccc
            padding 0
            height 25px
            line-height 25px
            text-indent 8px
            vertical-align top
            width calc(100% - 90px)
            float left
          .code-btn
            width 80px
            border 1px solid #ccc
            height 25px
            line-height 25px
            font-size 12px
            text-align center
            float right
      .login-btn
        width calc(100% - 20px)
        height 30px
        line-height 30px
        text-align center
        border-radius 5px
        background #fc4c02
        color #fff
        margin 10px auto 0 auto
        font-size 14px
.login-container::before
  width 100vw
  height 100vh
  background rgba(0, 0, 0, .5)
  content ''
  position fixed
  left 0
  top 0
  z-index 99

#qrCodeUrl
  iframe
    >>>
      .qr-box
        width 200px !important
        height 200px !important
</style>
